<div class="ticket-details-header">
  <div class="ticket-details-header__symbols">
    <rs-web-status-badge [state]="state"></rs-web-status-badge>
    <div class="ticket-details-header__icons">
      @if (deleteButton) {
        <rs-web-icon
          [cursor]="'pointer'"
          [size]="20"
          [color]="'red'"
          [icon]="immomioIconName.Trash"
          (tapped)="cancelTicketEvent.emit()"
        ></rs-web-icon>
      }
      <rs-web-icon
        [cursor]="'pointer'"
        [size]="20"
        [icon]="immomioIconName.Close"
        (tapped)="closeEvent.emit()"
      ></rs-web-icon>
    </div>
  </div>
  <div class="ticket-details-header__title h4 primary-text">{{ title }}</div>
  @if (externalId) {
    <div class="d-flex align-items-center">
      <rs-web-icon [icon]="immomioIconName.Ticket" [size]="16"></rs-web-icon>
      <rs-web-label
        [text]="'ticket.ticket_id' | translate"
        className="primary-text p-r-5 ms-1"
      ></rs-web-label>
      <rs-web-label [text]="externalId" className="secondary-text p-r-5"></rs-web-label>
      <rs-web-icon [icon]="immomioIconName.Copy" [size]="16" (tapped)="copy(externalId)">
      </rs-web-icon>
      @if (copied) {
        <rs-web-label
          [text]="'general.copied' | translate"
          className="secondary-text p-l-5"
        ></rs-web-label>
      }
    </div>
  }
</div>
